import React from 'react'

const BreadcrumbsSettingsIcon = () => (
  <svg
    width="20"
    height="22"
    viewBox="0 0 20 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.5281 6.73421L17.9057 5.65412C17.3791 4.7402 16.2121 4.42492 15.297 4.94931V4.94931C14.8613 5.20594 14.3415 5.27875 13.8521 5.15168C13.3628 5.02462 12.944 4.70811 12.6883 4.27197C12.5237 3.99474 12.4353 3.67899 12.432 3.35664V3.35664C12.4468 2.83982 12.2518 2.339 11.8915 1.96827C11.5311 1.59753 11.036 1.38846 10.5189 1.38867H9.26494C8.7584 1.38867 8.27275 1.59051 7.91544 1.94954C7.55812 2.30857 7.35861 2.79519 7.36105 3.30172V3.30172C7.34603 4.34752 6.49392 5.18741 5.448 5.1873C5.12565 5.18395 4.80989 5.09554 4.53267 4.93101V4.93101C3.6175 4.40661 2.45055 4.72189 1.92397 5.63581L1.25578 6.73421C0.729846 7.64699 1.04084 8.8132 1.95143 9.34291V9.34291C2.54334 9.68464 2.90797 10.3162 2.90797 10.9997C2.90797 11.6831 2.54334 12.3147 1.95143 12.6564V12.6564C1.04199 13.1825 0.730663 14.3459 1.25578 15.2559V15.2559L1.88736 16.3452C2.13408 16.7904 2.54804 17.1189 3.03763 17.258C3.52722 17.3972 4.05208 17.3355 4.49606 17.0866V17.0866C4.93252 16.8319 5.45262 16.7622 5.94078 16.8928C6.42893 17.0234 6.84467 17.3436 7.0956 17.7823C7.26013 18.0595 7.34854 18.3752 7.35189 18.6976V18.6976C7.35189 19.7541 8.20839 20.6106 9.26494 20.6106H10.5189C11.5719 20.6107 12.4269 19.7597 12.432 18.7068V18.7068C12.4295 18.1986 12.6303 17.7106 12.9896 17.3513C13.3489 16.992 13.8369 16.7913 14.345 16.7937C14.6666 16.8023 14.9811 16.8904 15.2604 17.05V17.05C16.1731 17.5759 17.3394 17.2649 17.8691 16.3543V16.3543L18.5281 15.2559C18.7832 14.8181 18.8532 14.2966 18.7226 13.807C18.5921 13.3173 18.2717 12.9 17.8324 12.6473V12.6473C17.3932 12.3946 17.0728 11.9772 16.9422 11.4875C16.8117 10.9979 16.8817 10.4764 17.1368 10.0386C17.3027 9.74893 17.5428 9.50879 17.8324 9.34291V9.34291C18.7376 8.81349 19.0478 7.65409 18.5281 6.74336V6.74336V6.73421Z"
      stroke="#004360"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle
      cx="9.89592"
      cy="10.9994"
      r="2.63616"
      stroke="#004360"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default BreadcrumbsSettingsIcon
